import React from "react";

import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

import Logo from "../../static/opms_48x48.png";

type FooterProps = {
  width: string | number;
};

// TODO: Fill this footer out with some useful information
export const Footer = ({
  width,
}: FooterProps): React.FunctionComponentElement<FooterProps> => (
  <Box display="flex" justifyContent="center" width={width} p={1}>
    <Box width="16px" height="16px" marginRight="5px">
      <img src={Logo} alt="Logo" width="100%" height="100%"></img>
    </Box>
    <Typography variant="caption">
      {`Powered by OPMS - Version ${process.env.REACT_APP_OPMS_VERSION}`}
    </Typography>
  </Box>
);
